import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aceites/manual_usuario.webp")